/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".hd--error-dialog[_ngcontent-%COMP%]{text-align:center}.hd--error-dialog[_ngcontent-%COMP%]   .hd--error-dialog-icon[_ngcontent-%COMP%]{width:auto;height:auto;font-size:5rem}"];
export { styles as styles };
